import { StreamData } from 'types/streamData'
import WidgetType from 'enums/WidgetType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const urlResolver: FieldResolver = (metadata: Metadata) => {
  let url = metadata.getUrl()
  if (
    (metadata.getWidgetType() &&
      metadata.getWidgetType() === WidgetType.SOCIAL_WEB_POPULAR_LINKS) ||
    metadata.getWidgetType() === WidgetType.AUDIENCE_POPULAR_LINKS
  ) {
    url = metadata.getMentionedUrls()![0].url!
  }

  return { url } as StreamData
}

export default urlResolver
